import classNames from 'classnames';
import React, { useContext } from 'react';

import { RicosNodeContext, RicosNodeContextProvider } from './../../ricos-context';
import type { NodeViewRendererProps } from './../../ricos-types';

import { TABLE_PLUGIN_CELL } from '../data-hooks';
import styles from '../statics/styles/cell-scss';
import CellBorders from './CellBorders';

const TableCell = ({ node, nodeIndex, RicosNodesRenderer }: NodeViewRendererProps) => {
  const { parentNode, parentIndex } = useContext(RicosNodeContext);
  const { borderColors, cellStyle } = node?.tableCellData || {};
  const isHeaderCell =
    (parentIndex === 0 && parentNode?.tableData?.rowHeader) ||
    (nodeIndex === 0 && parentNode?.tableData?.columnHeader);
  const Tag = isHeaderCell ? 'th' : 'td';

  const style: { backgroundColor?: string; verticalAlign?: string } = {};
  cellStyle?.backgroundColor && (style.backgroundColor = cellStyle.backgroundColor);
  cellStyle?.verticalAlignment && (style.verticalAlign = cellStyle.verticalAlignment.toLowerCase());

  return (
    <Tag
      data-hook={TABLE_PLUGIN_CELL}
      className={classNames(styles.cell, isHeaderCell && styles.header)}
      style={style}
    >
      <div className={classNames(styles.editor, styles.view)}>
        <RicosNodeContextProvider parentNode={parentNode} parentIndex={nodeIndex}>
          <RicosNodesRenderer nodes={node.nodes ?? []} shouldParagraphApplyTextStyle />
        </RicosNodeContextProvider>
      </div>
      {CellBorders({ borders: borderColors })}
    </Tag>
  );
};

const TableCellRenderer = ({ node, ...props }: NodeViewRendererProps) => {
  return <TableCell key={node.id} node={node} {...props} />;
};

export default TableCellRenderer;
